const countryData = [
  {
    name: "Afghanistan",
    otherNames: [],
    code: "AF",
    capital: "Kabul",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/AF",
    area: 652230,
    density: 63,
    population: 41128771,
    populationrank: 36,
    arearank: 40,
    densityrank: 123,
  },
  {
    name: "Albania",
    otherNames: [],
    code: "AL",
    capital: "Tirana",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/AL",
    area: 28748,
    density: 99,
    population: 2842321,
    populationrank: 136,
    arearank: 141,
    densityrank: 91,
  },
  {
    name: "Algeria",
    otherNames: [],
    code: "DZ",
    capital: "Algiers",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/DZ",
    area: 2381741,
    density: 19,
    population: 44903225,
    populationrank: 34,
    arearank: 10,
    densityrank: 168,
  },
  {
    name: "Andorra",
    otherNames: [],
    code: "AD",
    capital: "Andorra La Vella",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/AD",
    area: 468,
    density: 171,
    population: 79824,
    populationrank: 187,
    arearank: 181,
    densityrank: 56,
  },
  {
    name: "Angola",
    otherNames: [],
    code: "AO",
    capital: "Luanda",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/AO",
    area: 1246700,
    density: 29,
    population: 35588987,
    populationrank: 42,
    arearank: 22,
    densityrank: 152,
  },
  {
    name: "Antigua and Barbuda",
    otherNames: ["Antigua", "Antigua Barbuda"],
    code: "AG",
    capital: "Saint Johns",
    otherCapitals: ["St. Johns"],
    region: "North America",
    flag: "https://countryflagsapi.com/png/AG",
    area: 442,
    density: 212,
    population: 93763,
    populationrank: 186,
    arearank: 184,
    densityrank: 50,
  },
  {
    name: "Argentina",
    otherNames: [],
    code: "AR",
    capital: "Buenos Aires",
    otherCapitals: [],
    region: "South America",
    flag: "https://countryflagsapi.com/png/AR",
    area: 2780400,
    density: 16,
    population: 45510318,
    populationrank: 33,
    arearank: 8,
    densityrank: 178,
  },
  {
    name: "Armenia",
    otherNames: [],
    code: "AM",
    capital: "Yerevan",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/AM",
    area: 29743,
    density: 93,
    population: 2780469,
    populationrank: 138,
    arearank: 139,
    densityrank: 98,
  },
  {
    name: "Australia",
    otherNames: [],
    code: "AU",
    capital: "Canberra",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/AU",
    area: 7692024,
    density: 3,
    population: 26177413,
    populationrank: 55,
    arearank: 6,
    densityrank: 195,
  },
  {
    name: "Austria",
    otherNames: [],
    code: "AT",
    capital: "Vienna",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/AT",
    area: 83871,
    density: 107,
    population: 8939617,
    populationrank: 99,
    arearank: 113,
    densityrank: 85,
  },
  {
    name: "Azerbaijan",
    otherNames: [],
    code: "AZ",
    capital: "Baku",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/AZ",
    area: 86600,
    density: 120,
    population: 10358074,
    populationrank: 91,
    arearank: 112,
    densityrank: 73,
  },
  {
    name: "Bahamas",
    otherNames: ["The Bahamas"],
    code: "BS",
    capital: "Nassau",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/BS",
    area: 13943,
    density: 29,
    population: 409984,
    populationrank: 172,
    arearank: 156,
    densityrank: 155,
  },
  {
    name: "Bahrain",
    otherNames: [],
    code: "BH",
    capital: "Manama",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/BH",
    area: 765,
    density: 1924,
    population: 1472233,
    populationrank: 153,
    arearank: 175,
    densityrank: 3,
  },
  {
    name: "Bangladesh",
    otherNames: [],
    code: "BD",
    capital: "Dhaka",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/BD",
    area: 147570,
    density: 1160,
    population: 171186372,
    populationrank: 8,
    arearank: 92,
    densityrank: 6,
  },
  {
    name: "Barbados",
    otherNames: [],
    code: "BB",
    capital: "Bridgetown",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/BB",
    area: 430,
    density: 655,
    population: 281635,
    populationrank: 176,
    arearank: 185,
    densityrank: 9,
  },
  {
    name: "Belarus",
    otherNames: [],
    code: "BY",
    capital: "Minsk",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/BY",
    area: 207600,
    density: 46,
    population: 9534954,
    populationrank: 96,
    arearank: 84,
    densityrank: 139,
  },
  {
    name: "Belgium",
    otherNames: [],
    code: "BE",
    capital: "Brussels",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/BE",
    area: 30528,
    density: 382,
    population: 11655930,
    populationrank: 81,
    arearank: 137,
    densityrank: 24,
  },
  {
    name: "Belize",
    otherNames: [],
    code: "BZ",
    capital: "Belmopan",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/BZ",
    area: 22966,
    density: 18,
    population: 405272,
    populationrank: 173,
    arearank: 148,
    densityrank: 173,
  },
  {
    name: "Benin",
    otherNames: [],
    code: "BJ",
    capital: "Porto-Novo",
    otherCapitals: ["Cotonou"],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/BJ",
    area: 112622,
    density: 119,
    population: 13352864,
    populationrank: 77,
    arearank: 100,
    densityrank: 76,
  },
  {
    name: "Bhutan",
    otherNames: [],
    code: "BT",
    capital: "Thimphu",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/BT",
    area: 38394,
    density: 20,
    population: 782455,
    populationrank: 163,
    arearank: 133,
    densityrank: 167,
  },
  {
    name: "Bolivia",
    otherNames: [],
    code: "BO",
    capital: "La Paz",
    otherCapitals: ["Sucre"],
    region: "South America",
    flag: "https://countryflagsapi.com/png/BO",
    area: 1098581,
    density: 11,
    population: 12224110,
    populationrank: 80,
    arearank: 27,
    densityrank: 183,
  },
  {
    name: "Bosnia and Herzegovina",
    otherNames: ["Bosnia", "Bosnia Herzegovina"],
    code: "BA",
    capital: "Sarajevo",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/BA",
    area: 51209,
    density: 63,
    population: 3233526,
    populationrank: 135,
    arearank: 125,
    densityrank: 124,
  },
  {
    name: "Botswana",
    otherNames: [],
    code: "BW",
    capital: "Gaborone",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/BW",
    area: 582000,
    density: 5,
    population: 2630296,
    populationrank: 142,
    arearank: 46,
    densityrank: 189,
  },
  {
    name: "Brazil",
    otherNames: ["Brasil"],
    code: "BR",
    capital: "Brasilia",
    otherCapitals: [],
    region: "South America",
    flag: "https://countryflagsapi.com/png/BR",
    area: 8515767,
    density: 25,
    population: 215313498,
    populationrank: 7,
    arearank: 5,
    densityrank: 161,
  },
  {
    name: "Brunei",
    otherNames: [],
    code: "BN",
    capital: "Bandar Seri Begawan",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/BN",
    area: 5765,
    density: 78,
    population: 449002,
    populationrank: 171,
    arearank: 166,
    densityrank: 109,
  },
  {
    name: "Bulgaria",
    otherNames: [],
    code: "BG",
    capital: "Sofia",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/BG",
    area: 110879,
    density: 61,
    population: 6781953,
    populationrank: 107,
    arearank: 103,
    densityrank: 125,
  },
  {
    name: "Burkina Faso",
    otherNames: [],
    code: "BF",
    capital: "Ouagadougou",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/BF",
    area: 272967,
    density: 83,
    population: 22673762,
    populationrank: 58,
    arearank: 74,
    densityrank: 103,
  },
  {
    name: "Burundi",
    otherNames: [],
    code: "BI",
    capital: "Gitega",
    otherCapitals: ["Bujumbura"],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/BI",
    area: 27834,
    density: 463,
    population: 12889576,
    populationrank: 78,
    arearank: 143,
    densityrank: 17,
  },
  {
    name: "Cambodia",
    otherNames: [],
    code: "KH",
    capital: "Phnom Penh",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/KH",
    area: 181035,
    density: 93,
    population: 16767842,
    populationrank: 73,
    arearank: 88,
    densityrank: 96,
  },
  {
    name: "Cameroon",
    otherNames: [],
    code: "CM",
    capital: "Yaounde",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/CM",
    area: 475442,
    density: 59,
    population: 27914536,
    populationrank: 53,
    arearank: 53,
    densityrank: 127,
  },
  {
    name: "Canada",
    otherNames: [],
    code: "CA",
    capital: "Ottawa",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/CA",
    area: 9984670,
    density: 4,
    population: 38454327,
    populationrank: 39,
    arearank: 2,
    densityrank: 190,
  },
  {
    name: "Cape Verde",
    otherNames: ["Cabo Verde"],
    code: "CV",
    capital: "Praia",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/CV",
    area: 4033,
    density: 147,
    population: 593149,
    populationrank: 168,
    arearank: 168,
    densityrank: 63,
  },
  {
    name: "Central African Republic",
    otherNames: [],
    code: "CF",
    capital: "Bangui",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/CF",
    area: 622984,
    density: 9,
    population: 5579144,
    populationrank: 116,
    arearank: 42,
    densityrank: 184,
  },
  {
    name: "Chad",
    otherNames: [],
    code: "TD",
    capital: "N'Djamena",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/TD",
    area: 1284000,
    density: 14,
    population: 17723315,
    populationrank: 69,
    arearank: 20,
    densityrank: 181,
  },
  {
    name: "Chile",
    otherNames: [],
    code: "CL",
    capital: "Santiago",
    otherCapitals: ["Valparaiso"],
    region: "South America",
    flag: "https://countryflagsapi.com/png/CL",
    area: 756102,
    density: 26,
    population: 19603733,
    populationrank: 65,
    arearank: 37,
    densityrank: 160,
  },
  {
    name: "China",
    otherNames: ["People's Republic of China"],
    code: "CN",
    capital: "Beijing",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/CN",
    area: 9706961,
    density: 147,
    population: 1425887337,
    populationrank: 1,
    arearank: 3,
    densityrank: 62,
  },
  {
    name: "Colombia",
    otherNames: [],
    code: "CO",
    capital: "Bogota",
    otherCapitals: [],
    region: "South America",
    flag: "https://countryflagsapi.com/png/CO",
    area: 1141748,
    density: 45,
    population: 51874024,
    populationrank: 28,
    arearank: 25,
    densityrank: 140,
  },
  {
    name: "Comoros",
    otherNames: [],
    code: "KM",
    capital: "Moroni",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/KM",
    area: 1862,
    density: 449,
    population: 836774,
    populationrank: 161,
    arearank: 172,
    densityrank: 18,
  },
  {
    name: "Costa Rica",
    otherNames: [],
    code: "CR",
    capital: "San Jose",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/CR",
    area: 51100,
    density: 101,
    population: 5180829,
    populationrank: 123,
    arearank: 126,
    densityrank: 90,
  },
  {
    name: "Croatia",
    otherNames: [],
    code: "HR",
    capital: "Zagreb",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/HR",
    area: 56594,
    density: 71,
    population: 4030358,
    populationrank: 129,
    arearank: 124,
    densityrank: 115,
  },
  {
    name: "Cuba",
    otherNames: [],
    code: "CU",
    capital: "Havana",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/CU",
    area: 109884,
    density: 102,
    population: 11212191,
    populationrank: 85,
    arearank: 104,
    densityrank: 89,
  },
  {
    name: "Cyprus",
    otherNames: [],
    code: "CY",
    capital: "Nicosia",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/CY",
    area: 9251,
    density: 135,
    population: 1251488,
    populationrank: 157,
    arearank: 164,
    densityrank: 69,
  },
  {
    name: "Czech Republic",
    otherNames: ["Czechia"],
    code: "CZ",
    capital: "Prague",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/CZ",
    area: 78865,
    density: 133,
    population: 10493986,
    populationrank: 88,
    arearank: 115,
    densityrank: 70,
  },
  {
    name: "Democratic Republic of the Congo",
    otherNames: ["Congo", "DRC", "Democratic Republic of  Congo"],
    code: "CD",
    capital: "Kinshasa",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/CD",
    area: 2344858,
    density: 42,
    population: 99010212,
    populationrank: 15,
    arearank: 11,
    densityrank: 142,
  },
  {
    name: "Denmark",
    otherNames: [],
    code: "DK",
    capital: "Copenhagen",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/DK",
    area: 43094,
    density: 136,
    population: 5882261,
    populationrank: 114,
    arearank: 130,
    densityrank: 68,
  },
  {
    name: "Djibouti",
    otherNames: [],
    code: "DJ",
    capital: "Djibouti",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/DJ",
    area: 23200,
    density: 48,
    population: 1120849,
    populationrank: 159,
    arearank: 147,
    densityrank: 138,
  },
  {
    name: "Dominica",
    otherNames: [],
    code: "DM",
    capital: "Roseau",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/DM",
    area: 751,
    density: 97,
    population: 72737,
    populationrank: 188,
    arearank: 176,
    densityrank: 93,
  },
  {
    name: "Dominican Republic",
    otherNames: [],
    code: "DO",
    capital: "Santo Domingo",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/DO",
    area: 48671,
    density: 231,
    population: 11228821,
    populationrank: 84,
    arearank: 128,
    densityrank: 46,
  },
  {
    name: "Ecuador",
    otherNames: [],
    code: "EC",
    capital: "Quito",
    otherCapitals: [],
    region: "South America",
    flag: "https://countryflagsapi.com/png/EC",
    area: 276841,
    density: 65,
    population: 18001000,
    populationrank: 67,
    arearank: 73,
    densityrank: 121,
  },
  {
    name: "Egypt",
    otherNames: [],
    code: "EG",
    capital: "Cairo",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/EG",
    area: 1002450,
    density: 111,
    population: 110990103,
    populationrank: 14,
    arearank: 29,
    densityrank: 82,
  },
  {
    name: "El Salvador",
    otherNames: [],
    code: "SV",
    capital: "San Salvador",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/SV",
    area: 21041,
    density: 301,
    population: 6336392,
    populationrank: 111,
    arearank: 149,
    densityrank: 29,
  },
  {
    name: "Equatorial Guinea",
    otherNames: [],
    code: "GQ",
    capital: "Malabo",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/GQ",
    area: 28051,
    density: 60,
    population: 1674908,
    populationrank: 151,
    arearank: 142,
    densityrank: 126,
  },
  {
    name: "Eritrea",
    otherNames: [],
    code: "ER",
    capital: "Asmara",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/ER",
    area: 117600,
    density: 31,
    population: 3684032,
    populationrank: 131,
    arearank: 99,
    densityrank: 151,
  },
  {
    name: "Estonia",
    otherNames: [],
    code: "EE",
    capital: "Tallinn",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/EE",
    area: 45227,
    density: 29,
    population: 1326062,
    populationrank: 155,
    arearank: 129,
    densityrank: 154,
  },
  {
    name: "Eswatini",
    otherNames: ["Swaziland"],
    code: "SZ",
    capital: "Mbabane",
    otherCapitals: ["Lobamba"],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/SZ",
    area: 17364,
    density: 69,
    population: 1201670,
    populationrank: 158,
    arearank: 154,
    densityrank: 118,
  },
  {
    name: "Ethiopia",
    otherNames: [],
    code: "ET",
    capital: "Addis Ababa",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/ET",
    area: 1104300,
    density: 112,
    population: 123379924,
    populationrank: 12,
    arearank: 26,
    densityrank: 80,
  },
  {
    name: "Fiji",
    otherNames: [],
    code: "FJ",
    capital: "Suva",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/FJ",
    area: 18272,
    density: 51,
    population: 929766,
    populationrank: 160,
    arearank: 152,
    densityrank: 134,
  },
  {
    name: "Finland",
    otherNames: [],
    code: "FI",
    capital: "Helsinki",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/FI",
    area: 338424,
    density: 16,
    population: 5540745,
    populationrank: 117,
    arearank: 65,
    densityrank: 179,
  },
  {
    name: "France",
    otherNames: [],
    code: "FR",
    capital: "Paris",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/FR",
    area: 551695,
    density: 117,
    population: 64626628,
    populationrank: 23,
    arearank: 48,
    densityrank: 77,
  },
  {
    name: "Gabon",
    otherNames: [],
    code: "GA",
    capital: "Libreville",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/GA",
    area: 267668,
    density: 9,
    population: 2388992,
    populationrank: 144,
    arearank: 76,
    densityrank: 185,
  },
  {
    name: "Gambia",
    otherNames: ["The Gambia"],
    code: "GM",
    capital: "Banjul",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/GM",
    area: 10689,
    density: 253,
    population: 2705992,
    populationrank: 140,
    arearank: 162,
    densityrank: 37,
  },
  {
    name: "Georgia",
    otherNames: [],
    code: "GE",
    capital: "Tbilisi",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/GE",
    area: 69700,
    density: 54,
    population: 3744385,
    populationrank: 130,
    arearank: 119,
    densityrank: 132,
  },
  {
    name: "Germany",
    otherNames: [],
    code: "DE",
    capital: "Berlin",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/DE",
    area: 357114,
    density: 233,
    population: 83369843,
    populationrank: 19,
    arearank: 62,
    densityrank: 44,
  },
  {
    name: "Ghana",
    otherNames: [],
    code: "GH",
    capital: "Accra",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/GH",
    area: 238533,
    density: 140,
    population: 33475870,
    populationrank: 47,
    arearank: 80,
    densityrank: 67,
  },
  {
    name: "Greece",
    otherNames: [],
    code: "GR",
    capital: "Athens",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/GR",
    area: 131990,
    density: 79,
    population: 10384971,
    populationrank: 90,
    arearank: 95,
    densityrank: 108,
  },
  {
    name: "Grenada",
    otherNames: [],
    code: "GD",
    capital: "St. Georges",
    otherCapitals: ["Saint Georges"],
    region: "North America",
    flag: "https://countryflagsapi.com/png/GD",
    area: 344,
    density: 365,
    population: 125438,
    populationrank: 181,
    arearank: 187,
    densityrank: 25,
  },
  {
    name: "Guatemala",
    otherNames: [],
    code: "GT",
    capital: "Guatemala City",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/GT",
    area: 108889,
    density: 164,
    population: 17843908,
    populationrank: 68,
    arearank: 105,
    densityrank: 58,
  },
  {
    name: "Guinea",
    otherNames: [],
    code: "GN",
    capital: "Conakry",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/GN",
    area: 245857,
    density: 56,
    population: 13859341,
    populationrank: 75,
    arearank: 77,
    densityrank: 130,
  },
  {
    name: "Guinea Bissau",
    otherNames: ["Guinea-Bissau"],
    code: "GW",
    capital: "Bissau",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/GW",
    area: 36125,
    density: 58,
    population: 2105566,
    populationrank: 147,
    arearank: 135,
    densityrank: 129,
  },
  {
    name: "Guyana",
    otherNames: [],
    code: "GY",
    capital: "Georgetown",
    otherCapitals: [],
    region: "South America",
    flag: "https://countryflagsapi.com/png/GY",
    area: 214969,
    density: 4,
    population: 808726,
    populationrank: 162,
    arearank: 83,
    densityrank: 192,
  },
  {
    name: "Haiti",
    otherNames: [],
    code: "HT",
    capital: "Port au Prince",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/HT",
    area: 27750,
    density: 417,
    population: 11584996,
    populationrank: 82,
    arearank: 144,
    densityrank: 23,
  },
  {
    name: "Honduras",
    otherNames: [],
    code: "HN",
    capital: "Tegucigalpa",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/HN",
    area: 112492,
    density: 93,
    population: 10432860,
    populationrank: 89,
    arearank: 101,
    densityrank: 97,
  },
  {
    name: "Hungary",
    otherNames: [],
    code: "HU",
    capital: "Budapest",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/HU",
    area: 93028,
    density: 107,
    population: 9967308,
    populationrank: 94,
    arearank: 108,
    densityrank: 84,
  },
  {
    name: "Iceland",
    otherNames: [],
    code: "IS",
    capital: "Reykjavik",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/IS",
    area: 103000,
    density: 4,
    population: 372899,
    populationrank: 174,
    arearank: 106,
    densityrank: 194,
  },
  {
    name: "India",
    otherNames: [],
    code: "IN",
    capital: "New Delhi",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/IN",
    area: 3287590,
    density: 431,
    population: 1417173173,
    populationrank: 2,
    arearank: 7,
    densityrank: 21,
  },
  {
    name: "Indonesia",
    otherNames: [],
    code: "ID",
    capital: "Jakarta",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/ID",
    area: 1904569,
    density: 145,
    population: 275501339,
    populationrank: 4,
    arearank: 14,
    densityrank: 64,
  },
  {
    name: "Iran",
    otherNames: [],
    code: "IR",
    capital: "Tehran",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/IR",
    area: 1648195,
    density: 54,
    population: 88550570,
    populationrank: 17,
    arearank: 17,
    densityrank: 131,
  },
  {
    name: "Iraq",
    otherNames: [],
    code: "IQ",
    capital: "Baghdad",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/IQ",
    area: 438317,
    density: 102,
    population: 44496122,
    populationrank: 35,
    arearank: 58,
    densityrank: 88,
  },
  {
    name: "Ireland",
    otherNames: [],
    code: "IE",
    capital: "Dublin",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/IE",
    area: 70273,
    density: 71,
    population: 5023109,
    populationrank: 124,
    arearank: 118,
    densityrank: 114,
  },
  {
    name: "Israel",
    otherNames: [],
    code: "IL",
    capital: "Jerusalem",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/IL",
    area: 20770,
    density: 435,
    population: 9038309,
    populationrank: 98,
    arearank: 150,
    densityrank: 19,
  },
  {
    name: "Italy",
    otherNames: [],
    code: "IT",
    capital: "Rome",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/IT",
    area: 301336,
    density: 196,
    population: 59037474,
    populationrank: 25,
    arearank: 72,
    densityrank: 52,
  },
  {
    name: "Ivory Coast",
    otherNames: ["Cote D'Ivoire", "Cote Divoire", "Côte d'Ivoire"],
    code: "CI",
    capital: "Yamoussoukro",
    otherCapitals: ["Abidjan"],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/CI",
    area: 322463,
    density: 87,
    population: 28160542,
    populationrank: 52,
    arearank: 69,
    densityrank: 101,
  },
  {
    name: "Jamaica",
    otherNames: [],
    code: "JM",
    capital: "Kingston",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/JM",
    area: 10991,
    density: 257,
    population: 2827377,
    populationrank: 137,
    arearank: 160,
    densityrank: 36,
  },
  {
    name: "Japan",
    otherNames: [],
    code: "JP",
    capital: "Tokyo",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/JP",
    area: 377930,
    density: 328,
    population: 123951692,
    populationrank: 11,
    arearank: 61,
    densityrank: 28,
  },
  {
    name: "Jordan",
    otherNames: [],
    code: "JO",
    capital: "Amman",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/JO",
    area: 89342,
    density: 126,
    population: 11285869,
    populationrank: 83,
    arearank: 110,
    densityrank: 72,
  },
  {
    name: "Kazakhstan",
    otherNames: [],
    code: "KZ",
    capital: "Nur Sultan",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/KZ",
    area: 2724900,
    density: 7,
    population: 19397998,
    populationrank: 66,
    arearank: 9,
    densityrank: 187,
  },
  {
    name: "Kenya",
    otherNames: [],
    code: "KE",
    capital: "Nairobi",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/KE",
    area: 580367,
    density: 93,
    population: 54027487,
    populationrank: 27,
    arearank: 47,
    densityrank: 95,
  },
  {
    name: "Kiribati",
    otherNames: [],
    code: "KI",
    capital: "Tarawa",
    otherCapitals: ["South Tarawa"],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/KI",
    area: 811,
    density: 162,
    population: 131232,
    populationrank: 180,
    arearank: 174,
    densityrank: 60,
  },
  {
    name: "Kosovo",
    otherNames: [],
    code: "XK",
    capital: "Pristina",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/xk",
    area: 10887,
    density: 166,
    population: 1802250,
    populationrank: 150,
    arearank: 161,
    densityrank: 57,
  },
  {
    name: "Kuwait",
    otherNames: [],
    code: "KW",
    capital: "Kuwait City",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/KW",
    area: 17818,
    density: 240,
    population: 4268873,
    populationrank: 128,
    arearank: 153,
    densityrank: 40,
  },
  {
    name: "Kyrgyzstan",
    otherNames: [],
    code: "KG",
    capital: "Bishkek",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/KG",
    area: 199951,
    density: 33,
    population: 6630623,
    populationrank: 109,
    arearank: 85,
    densityrank: 148,
  },
  {
    name: "Laos",
    otherNames: [],
    code: "LA",
    capital: "Vientiane",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/LA",
    area: 236800,
    density: 32,
    population: 7529475,
    populationrank: 103,
    arearank: 82,
    densityrank: 149,
  },
  {
    name: "Latvia",
    otherNames: [],
    code: "LV",
    capital: "Riga",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/LV",
    area: 64559,
    density: 29,
    population: 1850651,
    populationrank: 149,
    arearank: 122,
    densityrank: 153,
  },
  {
    name: "Lebanon",
    otherNames: [],
    code: "LB",
    capital: "Beirut",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/LB",
    area: 10452,
    density: 525,
    population: 5489739,
    populationrank: 118,
    arearank: 163,
    densityrank: 13,
  },
  {
    name: "Lesotho",
    otherNames: [],
    code: "LS",
    capital: "Maseru",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/LS",
    area: 30355,
    density: 76,
    population: 2305825,
    populationrank: 145,
    arearank: 138,
    densityrank: 113,
  },
  {
    name: "Liberia",
    otherNames: [],
    code: "LR",
    capital: "Monrovia",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/LR",
    area: 111369,
    density: 48,
    population: 5302681,
    populationrank: 120,
    arearank: 102,
    densityrank: 137,
  },
  {
    name: "Libya",
    otherNames: [],
    code: "LY",
    capital: "Tripoli",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/LY",
    area: 1759540,
    density: 4,
    population: 6812341,
    populationrank: 106,
    arearank: 16,
    densityrank: 191,
  },
  {
    name: "Liechtenstein",
    otherNames: [],
    code: "LI",
    capital: "Vaduz",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/LI",
    area: 160,
    density: 246,
    population: 39327,
    populationrank: 191,
    arearank: 192,
    densityrank: 39,
  },
  {
    name: "Lithuania",
    otherNames: [],
    code: "LT",
    capital: "Vilnius",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/LT",
    area: 65300,
    density: 42,
    population: 2750055,
    populationrank: 139,
    arearank: 121,
    densityrank: 144,
  },
  {
    name: "Luxembourg",
    otherNames: [],
    code: "LU",
    capital: "Luxembourg",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/LU",
    area: 2586,
    density: 250,
    population: 647599,
    populationrank: 165,
    arearank: 170,
    densityrank: 38,
  },
  {
    name: "Madagascar",
    otherNames: [],
    code: "MG",
    capital: "Antananarivo",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/MG",
    area: 587041,
    density: 50,
    population: 29611714,
    populationrank: 50,
    arearank: 45,
    densityrank: 135,
  },
  {
    name: "Malawi",
    otherNames: [],
    code: "MW",
    capital: "Lilongwe",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/MW",
    area: 118484,
    density: 172,
    population: 20405317,
    populationrank: 62,
    arearank: 98,
    densityrank: 55,
  },
  {
    name: "Malaysia",
    otherNames: [],
    code: "MY",
    capital: "Kuala Lumpur",
    otherCapitals: ["PutraJaya"],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/MY",
    area: 330803,
    density: 103,
    population: 33938221,
    populationrank: 45,
    arearank: 67,
    densityrank: 87,
  },
  {
    name: "Maldives",
    otherNames: [],
    code: "MV",
    capital: "Male",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/MV",
    area: 300,
    density: 1746,
    population: 523787,
    populationrank: 170,
    arearank: 189,
    densityrank: 4,
  },
  {
    name: "Mali",
    otherNames: [],
    code: "ML",
    capital: "Bamako",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/ML",
    area: 1240192,
    density: 18,
    population: 22593590,
    populationrank: 59,
    arearank: 23,
    densityrank: 171,
  },
  {
    name: "Malta",
    otherNames: [],
    code: "MT",
    capital: "Valletta",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/MT",
    area: 316,
    density: 1688,
    population: 533286,
    populationrank: 169,
    arearank: 188,
    densityrank: 5,
  },
  {
    name: "Marshall Islands",
    otherNames: [],
    code: "MH",
    capital: "Majuro",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/MH",
    area: 181,
    density: 230,
    population: 41569,
    populationrank: 190,
    arearank: 191,
    densityrank: 47,
  },
  {
    name: "Mauritania",
    otherNames: [],
    code: "MR",
    capital: "Nouakchott",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/MR",
    area: 1030700,
    density: 5,
    population: 4736139,
    populationrank: 125,
    arearank: 28,
    densityrank: 188,
  },
  {
    name: "Mauritius",
    otherNames: [],
    code: "MU",
    capital: "Port Louis",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/MU",
    area: 2040,
    density: 637,
    population: 1299469,
    populationrank: 156,
    arearank: 171,
    densityrank: 10,
  },
  {
    name: "Mexico",
    otherNames: [],
    code: "MX",
    capital: "Mexico City",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/MX",
    area: 1964375,
    density: 65,
    population: 127504125,
    populationrank: 10,
    arearank: 13,
    densityrank: 120,
  },
  {
    name: "Micronesia",
    otherNames: [],
    code: "FM",
    capital: "Palikir",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/FM",
    area: 702,
    density: 163,
    population: 114164,
    populationrank: 182,
    arearank: 179,
    densityrank: 59,
  },
  {
    name: "Moldova",
    otherNames: [],
    code: "MD",
    capital: "Chisinau",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/MD",
    area: 33846,
    density: 97,
    population: 3272996,
    populationrank: 134,
    arearank: 136,
    densityrank: 92,
  },
  {
    name: "Monaco",
    otherNames: [],
    code: "MC",
    capital: "Monaco",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/MC",
    area: 2,
    density: 18235,
    population: 36469,
    populationrank: 192,
    arearank: 196,
    densityrank: 1,
  },
  {
    name: "Mongolia",
    otherNames: [],
    code: "MN",
    capital: "Ulaanbaatar",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/MN",
    area: 1564110,
    density: 2,
    population: 3398366,
    populationrank: 133,
    arearank: 18,
    densityrank: 197,
  },
  {
    name: "Montenegro",
    otherNames: [],
    code: "ME",
    capital: "Podgorica",
    otherCapitals: ["Cetinje"],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/ME",
    area: 13812,
    density: 45,
    population: 627082,
    populationrank: 166,
    arearank: 157,
    densityrank: 141,
  },
  {
    name: "Morocco",
    otherNames: [],
    code: "MA",
    capital: "Rabat",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/MA",
    area: 446550,
    density: 84,
    population: 37457971,
    populationrank: 40,
    arearank: 57,
    densityrank: 102,
  },
  {
    name: "Mozambique",
    otherNames: [],
    code: "MZ",
    capital: "Maputo",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/MZ",
    area: 801590,
    density: 41,
    population: 32969518,
    populationrank: 48,
    arearank: 35,
    densityrank: 145,
  },
  {
    name: "Myanmar",
    otherNames: ["Burma"],
    code: "MM",
    capital: "Naypyidaw",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/MM",
    area: 676578,
    density: 80,
    population: 54179306,
    populationrank: 26,
    arearank: 39,
    densityrank: 107,
  },
  {
    name: "Namibia",
    otherNames: [],
    code: "NA",
    capital: "Windhoek",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/NA",
    area: 825615,
    density: 3,
    population: 2567012,
    populationrank: 143,
    arearank: 34,
    densityrank: 196,
  },
  {
    name: "Nauru",
    otherNames: [],
    code: "NR",
    capital: "Yaren",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/NR",
    area: 21,
    density: 603,
    population: 12668,
    populationrank: 195,
    arearank: 195,
    densityrank: 11,
  },
  {
    name: "Nepal",
    otherNames: [],
    code: "NP",
    capital: "Kathmandu",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/NP",
    area: 147181,
    density: 208,
    population: 30547580,
    populationrank: 49,
    arearank: 93,
    densityrank: 51,
  },
  {
    name: "Netherlands",
    otherNames: ["The Netherlands"],
    code: "NL",
    capital: "Amsterdam",
    otherCapitals: ["The Hague"],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/NL",
    area: 41850,
    density: 420,
    population: 17564014,
    populationrank: 71,
    arearank: 131,
    densityrank: 22,
  },
  {
    name: "New Zealand",
    otherNames: [],
    code: "NZ",
    capital: "Wellington",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/NZ",
    area: 270467,
    density: 19,
    population: 5185288,
    populationrank: 122,
    arearank: 75,
    densityrank: 169,
  },
  {
    name: "Nicaragua",
    otherNames: [],
    code: "NI",
    capital: "Managua",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/NI",
    area: 130373,
    density: 53,
    population: 6948392,
    populationrank: 105,
    arearank: 96,
    densityrank: 133,
  },
  {
    name: "Niger",
    otherNames: [],
    code: "NE",
    capital: "Niamey",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/NE",
    area: 1267000,
    density: 21,
    population: 26207977,
    populationrank: 54,
    arearank: 21,
    densityrank: 166,
  },
  {
    name: "Nigeria",
    otherNames: [],
    code: "NG",
    capital: "Abuja",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/NG",
    area: 923768,
    density: 237,
    population: 218541212,
    populationrank: 6,
    arearank: 31,
    densityrank: 41,
  },
  {
    name: "North Korea",
    otherNames: ["Democratic People's Republic of Korea"],
    code: "KP",
    capital: "Pyongyang",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/KP",
    area: 120538,
    density: 216,
    population: 26069416,
    populationrank: 56,
    arearank: 97,
    densityrank: 48,
  },
  {
    name: "North Macedonia",
    otherNames: ["Macedonia"],
    code: "MK",
    capital: "Skopje",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/MK",
    area: 25713,
    density: 81,
    population: 2093599,
    populationrank: 148,
    arearank: 146,
    densityrank: 106,
  },
  {
    name: "Norway",
    otherNames: [],
    code: "NO",
    capital: "Oslo",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/NO",
    area: 323802,
    density: 17,
    population: 5434319,
    populationrank: 119,
    arearank: 68,
    densityrank: 177,
  },
  {
    name: "Oman",
    otherNames: [],
    code: "OM",
    capital: "Muscat",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/OM",
    area: 309500,
    density: 15,
    population: 4576298,
    populationrank: 126,
    arearank: 71,
    densityrank: 180,
  },
  {
    name: "Pakistan",
    otherNames: [],
    code: "PK",
    capital: "Islamabad",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/PK",
    area: 881912,
    density: 267,
    population: 235824862,
    populationrank: 5,
    arearank: 33,
    densityrank: 34,
  },
  {
    name: "Palau",
    otherNames: [],
    code: "PW",
    capital: "Ngerulmud",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/PW",
    area: 459,
    density: 39,
    population: 18055,
    populationrank: 194,
    arearank: 182,
    densityrank: 146,
  },
  {
    name: "Palestine",
    otherNames: [],
    code: "PS",
    capital: "Ramallah",
    otherCapitals: ["Jerusalem"],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/PS",
    area: 6220,
    density: 844,
    population: 5250072,
    populationrank: 121,
    arearank: 165,
    densityrank: 7,
  },
  {
    name: "Panama",
    otherNames: [],
    code: "PA",
    capital: "Panama City",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/PA",
    area: 75417,
    density: 58,
    population: 4408581,
    populationrank: 127,
    arearank: 116,
    densityrank: 128,
  },
  {
    name: "Papua New Guinea",
    otherNames: [],
    code: "PG",
    capital: "Port Moresby",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/PG",
    area: 462840,
    density: 22,
    population: 10142619,
    populationrank: 93,
    arearank: 54,
    densityrank: 165,
  },
  {
    name: "Paraguay",
    otherNames: [],
    code: "PY",
    capital: "Asuncion",
    otherCapitals: [],
    region: "South America",
    flag: "https://countryflagsapi.com/png/PY",
    area: 406752,
    density: 17,
    population: 6780744,
    populationrank: 108,
    arearank: 59,
    densityrank: 175,
  },
  {
    name: "Peru",
    otherNames: [],
    code: "PE",
    capital: "Lima",
    otherCapitals: [],
    region: "South America",
    flag: "https://countryflagsapi.com/png/PE",
    area: 1285216,
    density: 26,
    population: 34049588,
    populationrank: 44,
    arearank: 19,
    densityrank: 159,
  },
  {
    name: "Philippines",
    otherNames: ["The Philippines"],
    code: "PH",
    capital: "Manila",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/PH",
    area: 342353,
    density: 338,
    population: 115559009,
    populationrank: 13,
    arearank: 63,
    densityrank: 26,
  },
  {
    name: "Poland",
    otherNames: [],
    code: "PL",
    capital: "Warsaw",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/PL",
    area: 312679,
    density: 127,
    population: 39857145,
    populationrank: 37,
    arearank: 70,
    densityrank: 71,
  },
  {
    name: "Portugal",
    otherNames: [],
    code: "PT",
    capital: "Lisbon",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/PT",
    area: 92090,
    density: 112,
    population: 10270865,
    populationrank: 92,
    arearank: 109,
    densityrank: 81,
  },
  {
    name: "Qatar",
    otherNames: [],
    code: "QA",
    capital: "Doha",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/QA",
    area: 11586,
    density: 233,
    population: 2695122,
    populationrank: 141,
    arearank: 159,
    densityrank: 45,
  },
  {
    name: "Republic of the Congo",
    otherNames: ["Congo", "Republic of Congo"],
    code: "CG",
    capital: "Brazzaville",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/CG",
    area: 342000,
    density: 17,
    population: 5970424,
    populationrank: 113,
    arearank: 64,
    densityrank: 176,
  },
  {
    name: "Romania",
    otherNames: [],
    code: "RO",
    capital: "Bucharest",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/RO",
    area: 238391,
    density: 82,
    population: 19659267,
    populationrank: 64,
    arearank: 81,
    densityrank: 104,
  },
  {
    name: "Russia",
    otherNames: [],
    code: "RU",
    capital: "Moscow",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/RU",
    area: 17098242,
    density: 8,
    population: 144713314,
    populationrank: 9,
    arearank: 1,
    densityrank: 186,
  },
  {
    name: "Rwanda",
    otherNames: [],
    code: "RW",
    capital: "Kigali",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/RW",
    area: 26338,
    density: 523,
    population: 13776698,
    populationrank: 76,
    arearank: 145,
    densityrank: 14,
  },
  {
    name: "Saint Kitts and Nevis",
    otherNames: ["Saint Kitts", "St. Kitts", "St. Kitts and Nevis"],
    code: "KN",
    capital: "Basseterre",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/KN",
    area: 261,
    density: 183,
    population: 47657,
    populationrank: 189,
    arearank: 190,
    densityrank: 54,
  },
  {
    name: "Saint Lucia",
    otherNames: ["St. Lucia"],
    code: "LC",
    capital: "Castries",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/LC",
    area: 616,
    density: 292,
    population: 179857,
    populationrank: 179,
    arearank: 180,
    densityrank: 32,
  },
  {
    name: "Saint Vincent and the Grenadines",
    otherNames: ["Saint Vincent", "St. Vincent"],
    code: "VC",
    capital: "Kingstown",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/VC",
    area: 389,
    density: 267,
    population: 103948,
    populationrank: 185,
    arearank: 186,
    densityrank: 35,
  },
  {
    name: "Samoa",
    otherNames: [],
    code: "WS",
    capital: "Apia",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/WS",
    area: 2842,
    density: 78,
    population: 222382,
    populationrank: 178,
    arearank: 169,
    densityrank: 110,
  },
  {
    name: "San Marino",
    otherNames: [],
    code: "SM",
    capital: "San Marino",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/SM",
    area: 61,
    density: 552,
    population: 33660,
    populationrank: 193,
    arearank: 193,
    densityrank: 12,
  },
  {
    name: "Sao Tome and Principe",
    otherNames: ["Sao Tome"],
    code: "ST",
    capital: "Sao Tome",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/ST",
    area: 964,
    density: 236,
    population: 227380,
    populationrank: 177,
    arearank: 173,
    densityrank: 43,
  },
  {
    name: "Saudi Arabia",
    otherNames: [],
    code: "SA",
    capital: "Riyadh",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/SA",
    area: 2149690,
    density: 17,
    population: 36408820,
    populationrank: 41,
    arearank: 12,
    densityrank: 174,
  },
  {
    name: "Senegal",
    otherNames: [],
    code: "SN",
    capital: "Dakar",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/SN",
    area: 196722,
    density: 88,
    population: 17316449,
    populationrank: 72,
    arearank: 86,
    densityrank: 100,
  },
  {
    name: "Serbia",
    otherNames: [],
    code: "RS",
    capital: "Belgrade",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/RS",
    area: 88361,
    density: 82,
    population: 7221365,
    populationrank: 104,
    arearank: 111,
    densityrank: 105,
  },
  {
    name: "Seychelles",
    otherNames: ["The Seychelles"],
    code: "SC",
    capital: "Victoria",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/SC",
    area: 452,
    density: 237,
    population: 107118,
    populationrank: 183,
    arearank: 183,
    densityrank: 42,
  },
  {
    name: "Sierra Leone",
    otherNames: [],
    code: "SL",
    capital: "Freetown",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/SL",
    area: 71740,
    density: 120,
    population: 8605718,
    populationrank: 102,
    arearank: 117,
    densityrank: 74,
  },
  {
    name: "Singapore",
    otherNames: [],
    code: "SG",
    capital: "Singapore",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/SG",
    area: 710,
    density: 8416,
    population: 5975689,
    populationrank: 112,
    arearank: 178,
    densityrank: 2,
  },
  {
    name: "Slovakia",
    otherNames: [],
    code: "SK",
    capital: "Bratislava",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/SK",
    area: 49037,
    density: 115,
    population: 5643453,
    populationrank: 115,
    arearank: 127,
    densityrank: 78,
  },
  {
    name: "Slovenia",
    otherNames: [],
    code: "SI",
    capital: "Ljubljana",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/SI",
    area: 20273,
    density: 105,
    population: 2119844,
    populationrank: 146,
    arearank: 151,
    densityrank: 86,
  },
  {
    name: "Solomon Islands",
    otherNames: [],
    code: "SB",
    capital: "Honiara",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/SB",
    area: 28896,
    density: 25,
    population: 724273,
    populationrank: 164,
    arearank: 140,
    densityrank: 163,
  },
  {
    name: "Somalia",
    otherNames: [],
    code: "SO",
    capital: "Mogadishu",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/SO",
    area: 637657,
    density: 28,
    population: 17597511,
    populationrank: 70,
    arearank: 41,
    densityrank: 156,
  },
  {
    name: "South Africa",
    otherNames: [],
    code: "ZA",
    capital: "Pretoria",
    otherCapitals: ["Cape Town", "Bloemfontein"],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/ZA",
    area: 1221037,
    density: 49,
    population: 59893885,
    populationrank: 24,
    arearank: 24,
    densityrank: 136,
  },
  {
    name: "South Korea",
    otherNames: ["Republic of Korea", "Korea"],
    code: "KR",
    capital: "Seoul",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/KR",
    area: 100210,
    density: 517,
    population: 51815810,
    populationrank: 29,
    arearank: 107,
    densityrank: 15,
  },
  {
    name: "South Sudan",
    otherNames: [],
    code: "SS",
    capital: "Juba",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/SS",
    area: 619745,
    density: 18,
    population: 10913164,
    populationrank: 86,
    arearank: 43,
    densityrank: 172,
  },
  {
    name: "Spain",
    otherNames: [],
    code: "ES",
    capital: "Madrid",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/ES",
    area: 505992,
    density: 94,
    population: 47558630,
    populationrank: 30,
    arearank: 51,
    densityrank: 94,
  },
  {
    name: "Sri Lanka",
    otherNames: [],
    code: "LK",
    capital: "Colombo",
    otherCapitals: ["Sri Jayawardenepura Kotte"],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/LK",
    area: 65610,
    density: 333,
    population: 21832143,
    populationrank: 61,
    arearank: 120,
    densityrank: 27,
  },
  {
    name: "Sudan",
    otherNames: [],
    code: "SD",
    capital: "Khartoum",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/SD",
    area: 1886068,
    density: 25,
    population: 46874204,
    populationrank: 32,
    arearank: 15,
    densityrank: 162,
  },
  {
    name: "Suriname",
    otherNames: [],
    code: "SR",
    capital: "Paramaribo",
    otherCapitals: [],
    region: "South America",
    flag: "https://countryflagsapi.com/png/SR",
    area: 163820,
    density: 4,
    population: 618040,
    populationrank: 167,
    arearank: 90,
    densityrank: 193,
  },
  {
    name: "Sweden",
    otherNames: [],
    code: "SE",
    capital: "Stockholm",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/SE",
    area: 450295,
    density: 23,
    population: 10549347,
    populationrank: 87,
    arearank: 55,
    densityrank: 164,
  },
  {
    name: "Switzerland",
    otherNames: [],
    code: "CH",
    capital: "Bern",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/CH",
    area: 41284,
    density: 212,
    population: 8740472,
    populationrank: 101,
    arearank: 132,
    densityrank: 49,
  },
  {
    name: "Syria",
    otherNames: [],
    code: "SY",
    capital: "Damascus",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/SY",
    area: 185180,
    density: 119,
    population: 22125249,
    populationrank: 60,
    arearank: 87,
    densityrank: 75,
  },
  {
    name: "Taiwan",
    otherNames: [],
    code: "TW",
    capital: "Taipei",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/TW",
    area: 36193,
    density: 660,
    population: 23893394,
    populationrank: 57,
    arearank: 134,
    densityrank: 8,
  },
  {
    name: "Tajikistan",
    otherNames: [],
    code: "TJ",
    capital: "Dushanbe",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/TJ",
    area: 143100,
    density: 70,
    population: 9952787,
    populationrank: 95,
    arearank: 94,
    densityrank: 116,
  },
  {
    name: "Tanzania",
    otherNames: [],
    code: "TZ",
    capital: "Dodoma",
    otherCapitals: ["Dar es Salaam"],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/TZ",
    area: 945087,
    density: 69,
    population: 65497748,
    populationrank: 22,
    arearank: 30,
    densityrank: 117,
  },
  {
    name: "Thailand",
    otherNames: [],
    code: "TH",
    capital: "Bangkok",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/TH",
    area: 513120,
    density: 140,
    population: 71697030,
    populationrank: 20,
    arearank: 50,
    densityrank: 66,
  },
  {
    name: "Timor Leste",
    otherNames: ["East Timor", "Timor-Leste"],
    code: "TL",
    capital: "Dili",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/TL",
    area: 14874,
    density: 90,
    population: 1341296,
    populationrank: 154,
    arearank: 155,
    densityrank: 99,
  },
  {
    name: "Togo",
    otherNames: [],
    code: "TG",
    capital: "Lome",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/TG",
    area: 56785,
    density: 156,
    population: 8848699,
    populationrank: 100,
    arearank: 123,
    densityrank: 61,
  },
  {
    name: "Tonga",
    otherNames: [],
    code: "TO",
    capital: "Nuku Alofa",
    otherCapitals: ["Nuku'alofa"],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/TO",
    area: 747,
    density: 143,
    population: 106858,
    populationrank: 184,
    arearank: 177,
    densityrank: 65,
  },
  {
    name: "Trinidad and Tobago",
    otherNames: ["Trinidad"],
    code: "TT",
    capital: "Port of Spain",
    otherCapitals: [],
    region: "North America",
    flag: "https://countryflagsapi.com/png/TT",
    area: 5130,
    density: 298,
    population: 1531044,
    populationrank: 152,
    arearank: 167,
    densityrank: 30,
  },
  {
    name: "Tunisia",
    otherNames: [],
    code: "TN",
    capital: "Tunis",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/TN",
    area: 163610,
    density: 76,
    population: 12356117,
    populationrank: 79,
    arearank: 91,
    densityrank: 112,
  },
  {
    name: "Turkey",
    otherNames: [],
    code: "TR",
    capital: "Ankara",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/TR",
    area: 783562,
    density: 109,
    population: 85341241,
    populationrank: 18,
    arearank: 36,
    densityrank: 83,
  },
  {
    name: "Turkmenistan",
    otherNames: [],
    code: "TM",
    capital: "Ashgabat",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/TM",
    area: 488100,
    density: 13,
    population: 6430770,
    populationrank: 110,
    arearank: 52,
    densityrank: 182,
  },
  {
    name: "Tuvalu",
    otherNames: [],
    code: "TV",
    capital: "Funafuti",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/TV",
    area: 26,
    density: 435,
    population: 11312,
    populationrank: 196,
    arearank: 194,
    densityrank: 20,
  },
  {
    name: "Uganda",
    otherNames: [],
    code: "UG",
    capital: "Kampala",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/UG",
    area: 241550,
    density: 196,
    population: 47249585,
    populationrank: 31,
    arearank: 79,
    densityrank: 53,
  },
  {
    name: "Ukraine",
    otherNames: [],
    code: "UA",
    capital: "Kyiv",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/UA",
    area: 603500,
    density: 66,
    population: 39701739,
    populationrank: 38,
    arearank: 44,
    densityrank: 119,
  },
  {
    name: "United Arab Emirates",
    otherNames: ["UAE"],
    code: "AE",
    capital: "Abu Dhabi",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/AE",
    area: 83600,
    density: 113,
    population: 9441129,
    populationrank: 97,
    arearank: 114,
    densityrank: 79,
  },
  {
    name: "United Kingdom",
    otherNames: ["UK"],
    code: "GB",
    capital: "London",
    otherCapitals: [],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/GB",
    area: 242900,
    density: 278,
    population: 67508936,
    populationrank: 21,
    arearank: 78,
    densityrank: 33,
  },
  {
    name: "United States of America",
    otherNames: ["USA", "United States", "The United States Of America"],
    code: "US",
    capital: "Washington DC",
    otherCapitals: ["Washington"],
    region: "North America",
    flag: "https://countryflagsapi.com/png/US",
    area: 9372610,
    density: 36,
    population: 338289857,
    populationrank: 3,
    arearank: 4,
    densityrank: 147,
  },
  {
    name: "Uruguay",
    otherNames: [],
    code: "UY",
    capital: "Montevideo",
    otherCapitals: [],
    region: "South America",
    flag: "https://countryflagsapi.com/png/UY",
    area: 181034,
    density: 19,
    population: 3422794,
    populationrank: 132,
    arearank: 89,
    densityrank: 170,
  },
  {
    name: "Uzbekistan",
    otherNames: [],
    code: "UZ",
    capital: "Tashkent",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/UZ",
    area: 447400,
    density: 77,
    population: 34627652,
    populationrank: 43,
    arearank: 56,
    densityrank: 111,
  },
  {
    name: "Vanuatu",
    otherNames: [],
    code: "VU",
    capital: "Port Vila",
    otherCapitals: [],
    region: "Oceania",
    flag: "https://countryflagsapi.com/png/VU",
    area: 12189,
    density: 27,
    population: 326740,
    populationrank: 175,
    arearank: 158,
    densityrank: 158,
  },
  {
    name: "Vatican City",
    otherNames: ["Vatican"],
    code: "VA",
    capital: "Vatican City",
    otherCapitals: ["Vatican"],
    region: "Europe",
    flag: "https://countryflagsapi.com/png/VA",
    area: 1,
    density: 510,
    population: 510,
    populationrank: 197,
    arearank: 197,
    densityrank: 16,
  },
  {
    name: "Venezuela",
    otherNames: [],
    code: "VE",
    capital: "Caracas",
    otherCapitals: [],
    region: "South America",
    flag: "https://countryflagsapi.com/png/VE",
    area: 916445,
    density: 31,
    population: 28301696,
    populationrank: 51,
    arearank: 32,
    densityrank: 150,
  },
  {
    name: "Vietnam",
    otherNames: [],
    code: "VN",
    capital: "Hanoi",
    otherCapitals: [],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/VN",
    area: 331212,
    density: 296,
    population: 98186856,
    populationrank: 16,
    arearank: 66,
    densityrank: 31,
  },
  {
    name: "Yemen",
    otherNames: [],
    code: "YE",
    capital: "Sanaa",
    otherCapitals: ["Sana", "Aden"],
    region: "Asia",
    flag: "https://countryflagsapi.com/png/YE",
    area: 527968,
    density: 64,
    population: 33696614,
    populationrank: 46,
    arearank: 49,
    densityrank: 122,
  },
  {
    name: "Zambia",
    otherNames: [],
    code: "ZM",
    capital: "Lusaka",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/ZM",
    area: 752612,
    density: 27,
    population: 20017675,
    populationrank: 63,
    arearank: 38,
    densityrank: 157,
  },
  {
    name: "Zimbabwe",
    otherNames: [],
    code: "ZW",
    capital: "Harare",
    otherCapitals: [],
    region: "Africa",
    flag: "https://countryflagsapi.com/png/ZW",
    area: 390757,
    density: 42,
    population: 16320537,
    populationrank: 74,
    arearank: 60,
    densityrank: 143,
  },
];

export default countryData;
